import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtService } from 'src/app/services/jwt.service';
import { ApiService } from 'src/app/services/api.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';

@Component({
  selector: 'app-user-activity',
  templateUrl: './user-activity.component.html',
  styleUrls: ['./user-activity.component.css']
})
export class UserActivityComponent implements OnInit {

  buttonClicked = false;
  clients = JSON.parse(sessionStorage.getItem('clients'));

  user = {
    client: '',
    id: ''
  }

  constructor( private snackbar : MatSnackBar, private jwt: JwtService, private api: ApiService, private mixpanel: MixpanelService ) { }

  ngOnInit(): void {
    this.mixpanel.track("page_view", { page: "User Activity", category: "Dashboard", button: "-"  })
    this.jwt.check();
  }

  getRes() {
    this.mixpanel.track("button_click", { page: "User Activity", category: "Dashboard", button:"Activity" })
    this.buttonClicked = true;
    let param = {
      client: this.user.client,
      userid: this.user.id,
    };
    this.api.userActivity(param).subscribe((data: any) => {
      this.buttonClicked = false;
      if(data.status) {
        this.snackbar.open( data.message, undefined , {
          duration: 5000,
          panelClass: 'success'
        });
        window.open( data.data.link );
      } else {
        this.snackbar.open( data.message, undefined , {
          duration: 5000,
          panelClass: 'failure'
        });
        this.buttonClicked = false;
      }
    },
    ( error ) => {
      this.buttonClicked = false;
    });
  }

}
